import React from 'react';

//motion
import { motion } from 'framer-motion';

//variants
import { fadeIn } from '../variants';

const Contact = () => {
  return (
    <section id='contact' className='py-16 section mb-5'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row'>
          {/* text */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 flex justify-start items-center'>
            <div>
              <h2 className='h2 text-[28px] lg:text-[32px] leading-tight uppercase text-accent font-medium mb-2 tracking-wide'>
                Get in touch
              </h2>
              <h2 className='text-[45px] lg:text-[90px] leading-none mb-12'>
                Let's work <br /> together!
              </h2>
            </div>
          </motion.div>

          {/* form */}
          <motion.form
            variants={fadeIn('left', 0.3)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 box-shadow-custom rounded-[50px] flex flex-col gap-y-6 p-12 items-start'
            action="https://formspree.io/f/mknlezjn" method="POST">
            <input className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all' type="text" name="username" placeholder='Name' required />
            <input className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all' type="email" name="email" placeholder='Email' required />
            <textarea className='bg-transparent border-b py-12 outline-none w-full placeholder:text-white focus:border-accent transition-all resize-none mb-12' name="message" placeholder='Message' required ></textarea>
            <button className='btn btn-lg' type="submit" >Send Message</button>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
